import { addLocale, useLocale } from 'ttag'

export default localeName => {
  if (!localeName.startsWith('en')) {
    return import(
      /* webpackChunkName: "locale-[request]" */ `../locales/${localeName}.po`
    ).then(exports => {
      addLocale(localeName, exports.default)
      useLocale(localeName)

      return localeName
    })
  }

  return Promise.resolve(localeName)
}
